__webpack_require__.o = (obj, prop) => (Object.hasOwn(obj, prop))